/* eslint-disable no-throw-literal */
/* eslint-disable camelcase */
import { getToken } from "../utils/authUtils";
import { parseJSON } from "./parseJSON";

const urlBase = `${process.env.API_URL}`;
const readUrl = (url = "") => `${urlBase}/${url}`;

const isTokenValid = Symbol("Global Detect of Token Validity");
const globalState = {
  [isTokenValid]: true,
};
export const postLogin = async ({ email, password, twofa, browserHash, backupCode }) => {
  const body = {
    email,
    password,
    ...(backupCode && { backupCode }),
    ...(browserHash && { browser_hash: browserHash }),
    ...(twofa && { twofa }),
  };

  const res = await fetch(readUrl("login"), {
    method: "POST",
    headers: { "Content-Type": "application/json" },
    body: JSON.stringify(body),
  });

  const parsedRes = await parseJSON(res).catch((r) => r);
  return parsedRes && parsedRes.success !== undefined ? parsedRes.success : parsedRes;
};

export const postForgotPassword = async ({ email }) => {
  let res = await fetch(readUrl("forgot"), {
    method: "POST",
    headers: {
      "Content-Type": "application/json",
    },
    body: JSON.stringify({ email }),
  });

  res = await parseJSON(res);

  return res.success;
};

export const postResetPassword = async ({ email, code, password, verification }) => {
  let res = await fetch(readUrl("reset"), {
    method: "POST",
    headers: {
      "Content-Type": "application/json",
    },
    body: JSON.stringify({ email, code, password, verification }),
  });

  res = await parseJSON(res).catch((r) => r);

  return res.success;
};

export const fetchAccess = async (path = "access") => {
  if (!globalState[isTokenValid]) {
    throw {
      httpCode: 423,
      error: "Token is invalid. Blocking requests until re-authenticated.",
    };
  }
  const auth = `Bearer ${getToken()}`;

  // eslint-disable-next-line no-useless-catch
  try {
    let res = await fetch(readUrl(path), {
      method: "GET",
      headers: {
        Accept: "application/json",
        Authorization: auth,
        "Content-Type": "application/json",
      },
    });
    res = await parseJSON(res);
    if (res.success) return res.success;

    globalState[isTokenValid] = false;

    if (res.httpCode && res.httpCode > 400) {
      throw {
        httpCode: res.status,
        error: `Token invalid: ${res.status}. Blocking further requests.`,
      };
    }

    return res;
  } catch (err) {
    throw err;
  }
};

export const resetTokenStatus = () => {
  globalState[isTokenValid] = true;
  // console.log("Token status reset. Requests allowed again.");
};
